/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const BellIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='0.8em'
			height='0.8em'
			fill={color}
			{...props}
		>
			<path
				d='M45.2 38.3c-.5-.4-4.3-4.1-4.3-16.2-.4-4.4-2.2-8.5-5.2-11.8-1.4-1.6-3.2-2.9-5.1-3.8v-.3c-.1-3.4-3-6.1-6.4-6-3.2.1-5.9 2.7-6 6v.3c-2 .9-3.7 2.2-5.1 3.8C10.5 13.6 9 17.8 9 22.1c0 12.1-3.8 15.7-4.3 16.2-1.3.6-2 2.1-1.7 3.5.4 1.5 1.7 2.5 3.3 2.5h10.2c.1 1 .6 1.9 1.3 2.6 3.7 3.9 9.8 4.1 13.7.5l.5-.5c.7-.7 1.2-1.6 1.5-2.6h10.2c1.5.1 2.9-.9 3.3-2.4.3-1.6-.5-3-1.8-3.6zM24.5 3.4c1.2.1 2.2.8 2.6 1.9-.9-.2-1.8.4-2.6.4-.9 0-1.8-.6-2.6-.4.4-1.1 1.4-1.8 2.6-1.9zm0 4.6c7.1 0 13.1 7.8 13.1 14.1 0 3.7.6 7.3 1.6 10.8H10.9c1-3.5 1.6-7.1 1.6-10.8 0-6.3 4.9-14.1 12-14.1zm.4 38.3c-1.5-.1-3-.8-3.9-2.1h8c-1 1.2-2.5 2-4.1 2.1zM6.6 40.7C8 39.6 9.1 38 9.8 36.3h30.5c.6 1.8 1.7 3.3 3.2 4.5H6.6z'
				style={{
					fillRule: 'evenodd',
					clipRule: 'evenodd'
				}}
			/>
		</svg>
	)
}

export default BellIcon
